export default "__VITE_ASSET__BYk9K90R__"